import { patchAccountDataService, profileService } from '@http/profileService'
import { getRoleEnum } from '@types'
import { selectCredentials } from '@views/loginView/state/loginSlice'
import { call, takeEvery, put, select } from 'redux-saga/effects'
import { getProfile, patchProfile, patchUserAction, profileFailed, profileSuccess } from './profileSlice'

export function* profileHttp() {
  const { cocap, userId } = yield select(selectCredentials)
  try {
    const user = yield call(profileService, userId, cocap)
    yield put(
      profileSuccess({
        profile: { ...user.person, role: getRoleEnum(user.person.role) },
        parent: user.parent
      })
    )
  } catch (e) {
    yield put(profileFailed(e.message))
  }
}

export function* patchAccountData({ payload }: patchUserAction) {
  const { cocap, userId } = yield select(selectCredentials)
  try {
    yield call(patchAccountDataService, userId || '', payload.accountData || {}, cocap || '')
    const user = yield call(profileService, userId, cocap)
    yield put(
      profileSuccess({
        profile: { ...user.person, role: getRoleEnum(user.person.role) },
        parent: user.parent
      })
    )
  } catch (e) {
    yield put(profileFailed(e.message))
  }
}

export default function* profileSaga() {
  yield takeEvery(getProfile.type, profileHttp)
  yield takeEvery(patchProfile.type, patchAccountData)
}
